<template>
  <v-row>
    <v-text-field
      :disabled="isDefaultValue"
      :error-messages="errorMessages"
      :hint="hint"
      :label="label"
      :prefix="prefix"
      :rules="contextRules"
      :suffix="suffix"
      :type="contextType"
      v-model="contextModel"
    >
    </v-text-field>
    <v-checkbox :disabled="checkboxDisabled" :label="checkboxText" bottom slot="activator" v-model="isDefaultValue" />
  </v-row>
</template>

<script>
export default {
  name: "TextFieldWithSetDefaultCheckbox",
  components: {},
  props: {
    model: {
      required: true
    },
    label: {
      default: null
    },
    hint: {
      default: null
    },
    type: {
      default: null
    },
    errorMessages: {
      default: () => [],
      required: false,
      type: Array
    },
    defaultCheckbox: {
      default: true
    },
    defaultValue: {
      default: null
    },
    checkboxText: {
      default: false
    },
    checkboxDisabled: {
      default: false
    },
    rules: {
      default: () => []
    },
    suffix: {
      default: null
    },
    prefix: {
      default: null
    }
  },
  computed: {
    contextCheckboxText() {
      if (this.checkboxText === false) {
        return this.$t("global.defaultValue");
      }
      return this.checkboxText;
    },
    contextModel: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit("update:model", val);
      }
    },
    contextType() {
      if (this.type === "number") {
        return null;
      }
      return this.type; // disabled bugged in firefox type number, instead of add validation
    },
    contextRules() {
      if (this.type === "number") {
        let rule = [v => !isNaN(v) || this.$t("global.error.notANumber")];
        for (let r of this.rules) {
          rule.push(r);
        }
        return rule;
      }
      return this.rules;
    },
    isDefaultValue: {
      get() {
        return this.model === this.defaultValue;
      },
      set(value) {
        if (value === true) {
          this.contextModel = this.defaultValue;
        } else {
          this.contextModel = this.defaultValue == null ? "" : this.defaultValue + " ";
        }
      }
    }
  },
  methods: {
    setDefaultValue() {
      this.contextModel = this.defaultValue;
    }
  }
};
</script>

<style scoped></style>
